import { createBrowserRouter, Navigate } from 'react-router-dom';
import HomePage from '../pages/HomePage';
import ConseilRHPage from '../pages/ConseilRHPage';
import DroitSocialPage from '../pages/DroitSocialPage';
import FormationRHPage from '../pages/FormationRHPage';
import AccompagnementCollectivitesPage from '../pages/AccompagnementCollectivitesPage';
import AuditRHPage from '../pages/AuditRHPage';

export const routes = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/conseil-rh',
    element: <ConseilRHPage />,
  },
  {
    path: '/droit-social',
    element: <DroitSocialPage />,
  },
  {
    path: '/formation-rh',
    element: <FormationRHPage />,
  },
  {
    path: '/accompagnement-collectivites',
    element: <AccompagnementCollectivitesPage />,
  },
  {
    path: '/audit-rh',
    element: <AuditRHPage />,
  },
  {
    path: '/services/particuliers',
    element: <Navigate to="/conseil-rh/" replace />,
  },
  {
    path: '/services/professionnels',
    element: <Navigate to="/audit-rh/" replace />,
  },
  {
    path: '/services/formations',
    element: <Navigate to="/formation-rh/" replace />,
  },
];

export const router = createBrowserRouter(routes);
